import { OddsFormat } from '../sportsbook-types';
import normalizeOdds from './normalize-odds';

const formatOdds = (odds: number, format: OddsFormat): string => {
	const normalizedOdds = normalizeOdds(odds);

	if (format === OddsFormat.AMERICAN) {
		// Move all digits to left of comma to minimize use of floating-point arithmetic
		// This assumes normalized odds has max 3 decimals
		const oddsInteger = Number((normalizedOdds * 1000).toFixed(0));
		if (oddsInteger >= 2000) {
			return `+${(oddsInteger - 1000) / 10}`;
		}
		return `${Math.floor(-100000 / (oddsInteger - 1000))}`;
	}

	if (normalizedOdds < 1.01 && normalizedOdds !== 1.0) {
		return normalizedOdds.toFixed(3);
	}
	return normalizedOdds.toFixed(2);
};

export default formatOdds;
